import { FAQSLandingPage } from '@/components/pages/faqs/FAQSLandingPage'
import { getAllFAQSPages } from '@/graphql/FAQS'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const pages = await getAllFAQSPages(preview)

  if (pages) {
    return { props: { faqs: pages.allFaqPages || [] } }
  }

  throw new Error('No Terms of Service active pages found')
}

export default FAQSLandingPage
